import { formatDate } from '../../../../app/header/utils'
import { TableAlign } from '../../../components/Table'
import { ExternalLink } from '../../../components/external-link'
import { ColumnId, ParsedFilingItem, TableColumnDefinition } from './types'

const DATE_FORMAT = 'MMM dd, yyyy'
const NULL_VALUE = '—'

export const FILINGS_COLUMNS: TableColumnDefinition[] = [
  {
    id: ColumnId.FilingDate,
    align: TableAlign.Left,
    name: 'Filing Date',
    renderColumn: (args: ParsedFilingItem) => {
      if (!args.filingDate) return NULL_VALUE
      return formatDate(args.filingDate, DATE_FORMAT)
    },
    sortable: true,
    compoundSort: [ColumnId.FilingDate, ColumnId.AccessionNumber],
  },
  {
    id: ColumnId.ReportDate,
    align: TableAlign.Left,
    name: 'Report Date',
    renderColumn: (args: ParsedFilingItem) => {
      if (!args.reportDate) return NULL_VALUE
      return formatDate(args.reportDate, DATE_FORMAT)
    },
    sortable: true,
    compoundSort: [ColumnId.ReportDate, ColumnId.AccessionNumber],
  },
  {
    id: ColumnId.Form,
    align: TableAlign.Left,
    name: 'Form',
    renderColumn: (args: ParsedFilingItem) => args.form || NULL_VALUE,
    sortable: true,
    compoundSort: [ColumnId.Form, ColumnId.AccessionNumber],
  },
  {
    id: ColumnId.Description,
    align: TableAlign.Left,
    name: 'Description',
    renderColumn: (args: ParsedFilingItem) => args.description || NULL_VALUE,
    sortable: false,
  },
  {
    id: ColumnId.Filing,
    align: TableAlign.Left,
    name: 'Filing',
    renderColumn: (args: ParsedFilingItem) => {
      if (!args.filing) return NULL_VALUE
      return <ExternalLink href={args.filing} className="tab-link" />
    },
  },
  {
    id: ColumnId.Document,
    align: TableAlign.Left,
    name: 'Document',
    renderColumn: (args: ParsedFilingItem) => {
      if (!args.document) return NULL_VALUE
      return <ExternalLink href={args.document} className="tab-link" />
    },
  },
  {
    id: ColumnId.AccessionNumber,
    name: 'AccessionNumber',
    renderColumn: () => null,
    hidden: true,
  },
]

export const VISIBLE_FILINGS_COLUMNS = FILINGS_COLUMNS.filter((col) => !col.hidden)
